import React, { useEffect, useMemo } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../Common/DataTable';
import { Cancel } from '../../media/images/Cancel';
import { Datatablestyle } from './utils/Constant';
import { SyncDownReportTableData } from './utils/TypeDashboard';
import { getSyncDownReport } from './redux/dashboardSlice';
import { RootState } from '../../redux/rootState';
import { stripCustPrefix } from '../../utils/CommonFunctions';
// import { PrintIcon } from '../../assets/TableIcons';

interface ISyncDownReportModal {
  open: boolean;
  handleClose: () => void;
  // handlePrinting: () => void;
}

export default function SyncDownReportModal({
  open, handleClose,
}: ISyncDownReportModal) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSyncDownReport());
  }, []);

  const { syncDownReportData } = useSelector((state:RootState) => state.dashboardReducer);

  const syncDownReports = useMemo(() => syncDownReportData?.map((item, index) => ({
    id: String(index + 1),
    jobOrder: item?.UnitId,
    custId: stripCustPrefix(item?.CustomerId),
    customerName: item?.CustomerName,
    siteName: item?.SiteName,
    analyst: item?.AnalystName,
    startDate: item?.StartDate,
    endDate: item?.EndDate,
  })), [syncDownReportData]);

  const receivedColumns = [
    { key: 'jobOrder', label: 'Job Order #' },
    { key: 'custId', label: 'Customer Id' },
    { key: 'customerName', label: 'Customer Name' },
    { key: 'siteName', label: 'Site Name' },
    { key: 'analyst', label: 'Analyst' },
    { key: 'startDate', label: 'Start Date' },
    { key: 'endDate', label: 'End Date' },
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Jobs Pending to be Synced by Analyst
          </div>
          <div className="cancel-icon" onClick={() => handleClose()}>
            <Cancel />
          </div>

        </div>
        <div className="customModalBtnContainer">
          {/* <div className="pointCursor" onClick={handlePrinting}>
            <PrintIcon />
          </div> */}
        </div>
        <DataTable<SyncDownReportTableData>
          data={syncDownReports || []}
          columns={receivedColumns}
          handleData={() => {}}
          totalRecords={10}
        />
      </Box>
    </Modal>
  );
}
